<template>
  <div class="permission-matrix px-2 pb-2">
    <table class="table is-bordered is-narrow is-fullwidth is-size-7 mb-0">
      <thead>
        <tr>
          <th class="has-background-light" style="min-width: 9rem"></th>
          <th
            v-for="column in columns"
            :key="column"
            class="has-text-centered has-background-light"
            style="width: 5rem"
          >
            {{ columnLabels[column] }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(row, rowIndex) in matrixRows" :key="rowIndex">
          <td class="has-text-weight-semibold">{{ row.label }}</td>
          <td v-for="column in columns" :key="column" class="has-text-centered">
            <template v-if="row[column]">
              <label class="checkbox">
                <span
                  v-if="isChanged(row[column])"
                  class="mr-1 has-text-danger"
                  title="Ndryshuar"
                >
                  <i class="fas fa-exclamation-triangle is-size-7"></i>
                </span>
                <input
                  v-model="row[column].value"
                  :disabled="!canEdit"
                  true-value="1"
                  false-value="0"
                  type="checkbox"
                />
              </label>
            </template>
            <span v-else class="has-text-grey-light">—</span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import {
  PERMISSION_MATRIX_COLUMNS,
  PERMISSION_MATRIX_COLUMN_LABELS,
  PERMISSION_MATRIX_CONFIG,
} from "./permission-matrix-config.js";

export default {
  props: {
    moduleKey: {
      type: String,
      required: true,
    },
    permissions: {
      type: Array,
      required: true,
    },
    canEdit: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    columns() {
      return PERMISSION_MATRIX_COLUMNS;
    },
    columnLabels() {
      return PERMISSION_MATRIX_COLUMN_LABELS;
    },
    matrixRows() {
      const config = PERMISSION_MATRIX_CONFIG[this.moduleKey];
      if (!config) return [];

      return config.rows.map((row) => {
        const cells = { label: row.label };
        this.columns.forEach((column) => {
          if (row[column]) {
            cells[column] = this.findPermission(row[column]);
          }
        });
        return cells;
      });
    },
  },
  methods: {
    findPermission(name) {
      return this.permissions.find((permission) => permission.name === name) || null;
    },
    isChanged(permission) {
      return Number.isInteger(permission.value) && permission.value != permission.original_value;
    },
  },
};
</script>

<style scoped>
.permission-matrix .table td,
.permission-matrix .table th {
  vertical-align: middle;
}
</style>
